import React from "react"
import { createRoot } from "react-dom/client"
import FlowCanvas from "./components/FlowCanvas"
import BlastRadiusCanvas from "./components/BlastRadiusCanvas"

// Make components available for mounting from Stimulus
window.FlowCanvas = FlowCanvas
window.BlastRadiusCanvas = BlastRadiusCanvas
window.React = React
window.createRoot = createRoot
